import { ReactNode } from 'react';
import { LANGUAGES } from '../../../../i18n';
import AppNavigation from '../AppNavigation/AppNavigation';

interface Props {
    children?: ReactNode;
}

const AppLayout = (props: Props) => {
    return (
        <div className="app">
            <AppNavigation languages={LANGUAGES} />
            {props.children}
        </div>
    );
};

export default AppLayout;
